var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1366,0 L1366,768 L0,768 L0,0 L1366,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44065784,2.92750482 C6.33065784,-0.97249518 12.6606578,-0.97249518 16.5606578,2.90750482 L17.7706578,1.69750482 C18.4006578,1.06750482 19.4806578,1.51750482 19.4806578,2.40750482 L19.4806578,6.99750482 C19.4806578,7.54750482 19.0306578,7.99750482 18.4806578,7.99750482 L13.8906578,7.99750482 C13.0006578,7.99750482 12.5506578,6.91750482 13.1906578,6.28750482 L15.1606578,4.31750482 C12.0406578,1.21750482 6.97065784,1.22750482 3.86065784,4.33750482 C3.00065784,5.19750482 2.37065784,6.21750482 1.98065784,7.32750482 C1.84065784,7.71750482 1.49065784,7.99750482 1.07065784,7.99750482 L0.960657841,7.99750482 C0.310657841,7.99750482 -0.159342159,7.35750482 0.0506578408,6.74750482 C0.540657841,5.32750482 1.35065784,4.01750482 2.44065784,2.92750482 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1161.0 -88.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.0 72.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(815.0 15.999999999999062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4893421592041705 8.002495179942343)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.45716772e-16,-4.4408921e-16 19.4806578,-4.4408921e-16 19.4806578,7.99750482 1.45716772e-16,7.99750482 1.45716772e-16,-4.4408921e-16",
    stroke: "none",
    fill: "#d5d5d5"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDisabled);
export default __webpack_public_path__ + "static/media/arrow-right-disabled.354095c1080cb14da1c04b9988ade568.svg";
export { ForwardRef as ReactComponent };